import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form", {
    staticClass: "dataFrom",
    attrs: {
      layout: "inline",
      form: _vm.form,
      labelAlign: "left"
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    staticClass: "searchBox",
    attrs: {
      label: _vm.$t("产品名称")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("产品名称"),
      allowClear: ""
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    staticClass: "searchBox",
    attrs: {
      label: _vm.$t("发布客户")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("发布客户"),
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.dropDownSearch
    },
    model: {
      value: _vm.form.customerId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "customerId", $$v);
      },
      expression: "form.customerId"
    }
  }, _vm._l(_vm.customer, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_c("a-tooltip", {
      attrs: {
        placement: "topLeft",
        title: item.name
      }
    }, [_vm._v(_vm._s(item.name))])], 1);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    staticClass: "searchBox",
    attrs: {
      label: _vm.$t("发布应用")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("发布应用"),
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.dropDownSearch
    },
    model: {
      value: _vm.form.applicationId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "applicationId", $$v);
      },
      expression: "form.applicationId"
    }
  }, _vm._l(_vm.applicationList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.applicationId
      }
    }, [_c("a-tooltip", {
      attrs: {
        placement: "topLeft",
        title: item.name
      }
    }, [_vm._v(_vm._s(item.name) + "(" + _vm._s(item.type == 1 ? "app" : item.type == 2 ? "h5" : item.type == 3 ? "pc" : _vm.$t("小程序")) + ")")])], 1);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("产品状态")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("状态"),
      allowClear: ""
    },
    model: {
      value: _vm.form.status,
      callback: function ($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 0
    }
  }, [_vm._v(_vm._s(_vm.$t("已禁用")))]), _c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("已启用")))])], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    staticClass: "searchBox",
    attrs: {
      label: _vm.$t("创建时间")
    }
  }, [_c("a-range-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: "",
      format: _vm.getFormatDate()
    },
    on: {
      change: _vm.onChange
    },
    model: {
      value: _vm.dateArr,
      callback: function ($$v) {
        _vm.dateArr = $$v;
      },
      expression: "dateArr"
    }
  })], 1)], 1)], 1), _c("a-row", [_c("div", {
    staticClass: "marginT10"
  }, [_c("a-form-item", [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.searchFun
    }
  }, [_vm._v(_vm._s(_vm.$t("查询")))]), _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "edit"
    },
    on: {
      click: function ($event) {
        ;
        _vm.form = {}, _vm.dateArr = [];
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("重置")))]), _vm.isAuth("home.customerInsuranceStore") ? _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "add",
      icon: "plus"
    },
    on: {
      click: function ($event) {
        return _vm.$router.push({
          name: "releaseInfo",
          params: {
            id: -1,
            insuranceId: -1
          }
        });
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("新增发布")))]) : _vm._e(), _vm.isAuth("home.customerInsuranceGenerateQrCode") ? _c("a-button", {
    attrs: {
      type: "primary2"
    },
    on: {
      click: _vm.handleCode
    }
  }, [_vm._v(_vm._s(_vm.$t("获取二维码")))]) : _vm._e()], 1)], 1)])], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.COLUMNS,
      "data-source": _vm.data,
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function (text, record) {
        return [_c("a-switch", {
          attrs: {
            checked: text == 1 ? true : false
          },
          on: {
            click: function ($event) {
              return _vm.checkedFun(record);
            }
          }
        })];
      }
    }, {
      key: "action",
      fn: function (text, record) {
        return [_vm.isAuth("home.customerInsuranceEdit") ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "releaseInfo",
                params: {
                  id: record.customerInsuranceId,
                  insuranceId: record.insuranceId
                }
              });
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))]) : _vm._e()];
      }
    }])
  }, _vm._l(_vm.COLUMNS, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _vm.codeShow ? _c("code-model", {
    ref: "codeRef",
    attrs: {
      customer: _vm.customer
    },
    on: {
      cancel: function ($event) {
        _vm.codeShow = false;
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };